import { tv } from 'tailwind-variants';

const popoverStyles = tv({
    slots: {
        content: `
      iris:rounded-(--comp-size-radius-popover)
      iris:bg-(--comp-color-background-popover-default)
      iris:p-(--comp-space-padding-popover-all)
      iris:shadow-elevation-03
      iris:data-[state=closed]:[animation:popoverBottomOut_var(--comp-motion-duration-popover-exit)_var(--comp-motion-easing-popover-exit)_forwards]
      iris:data-[side=top]:data-[state=closed]:[animation:popoverTopOut_var(--comp-motion-duration-popover-exit)_var(--comp-motion-easing-popover-exit)_forwards]
      iris:data-[state=open]:[animation:popoverBottomIn_var(--comp-motion-duration-popover-entry)_var(--comp-motion-easing-popover-entry)_forwards]
      iris:data-[side=top]:data-[state=open]:[animation:popoverTopIn_var(--comp-motion-duration-popover-entry)_var(--comp-motion-easing-popover-entry)_forwards]
    `,
    },
    variants: {
        inverse: {
            true: {
                content: `
          iris:bg-(--comp-color-background-popover-inverse)
          iris:text-(--comp-color-content-button-primary-inverse-rest)
        `,
            },
        },
    },
});

export { popoverStyles as default };
